import { trimSlashes } from '../../../utils'

const getSelectedSize = (product) => {
	try {
		const selectedOptions = product?.metadata?.configurableOptions ?? []
		const configurableOptions = product.productData?.configurableOptions ?? []
		const sizeOption = configurableOptions.find(({ attributeCode }) => attributeCode === 'size')

		const sizeAttributeId = sizeOption?.attributeId

		const sizeAttributeValue = selectedOptions.find(({ id }) => id === sizeAttributeId)?.value

		const selectedSize = sizeOption?.values.find(({ value }) => value === sizeAttributeValue)?.label
		return selectedSize
	} catch (error) {
		return undefined
	}
}

export const getProductPermalink = (product, { store }) =>
	trimSlashes(store?.baseUrl) + '/' + (product?.parentSku ?? product.sku)

export const cartItemsToSizebayProducts = ({ items = [], store }) =>
	items.map((item) => ({
		permalink: getProductPermalink(item, { store }),
		price: item.totals?.price ?? undefined,
		quantity: item.qty ?? undefined,
		size: getSelectedSize(item) ?? undefined,
		sku: item.parentSku ?? item.sku,
		feedProductId: item.id ?? item.productData.id ?? undefined,
	}))
